/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagComputedFormula } from '../../models/tag-computed-formula';
import { TagComputedFormulaValidateResult } from '../../models/tag-computed-formula-validate-result';

export interface ValidateFormula$Params {
      body: TagComputedFormula
}

export function validateFormula(http: HttpClient, rootUrl: string, params: ValidateFormula$Params, context?: HttpContext): Observable<StrictHttpResponse<TagComputedFormulaValidateResult>> {
  const rb = new RequestBuilder(rootUrl, validateFormula.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagComputedFormulaValidateResult>;
    })
  );
}

validateFormula.PATH = '/tags-computed/validate';
